module.exports = __webpack_public_path__ + "static/Kate-Eggers-c9f25d661a8866b6ee124faee6c4ab77.jpg";